import { name } from "aws-sdk/clients/importexport";
import { Entity, Property } from "./Definition";

export interface IItem {
    item: Entity | Property | null,
    sub: string | null
}

export interface IDimension {
    source: IItem,
    bin: string | null
}

export interface IMeasure {
    source: IItem,
    aggregation?: string
}

export interface IFilter {
    source: IItem,
    operation: string | null,
    value: string | null
}

export type IColorStyle = {
    scale: string | null,
    inverse?: boolean,
    color: string | null
}

export interface IRange {
    min: number | null,
    max: number | null
}

export interface ISizeStyle {
    minSize: number,
    maxSize: number
}

export interface IDwDimension {
    type: string;
    id: string;
    name: string;
    bin: string | null;
    stat?: string;
    feature?: string;
}

export interface IDwMeasure {
    type: string;
    id: string;
    name: string;
    stat?: string;
    bin?: string;
    aggregation?: string;
    source_id?: string[];
}

export interface IDwFilter {
    type: string;
    id: string;
    name: name;
    operation: string;
    value: any;
    feature?: string;
}

export interface IDwFilterWarapper {
    definitionId: number;
    filter: IDwFilter;
    bySelection: boolean;
}

export interface IDwCrossFilter {
    definitionId: number;
    filter: IDwFilter;
    enabled: boolean;
    bySelection: boolean;
    widgetInstanceId: string,
    widgetInstanceTitle: string,
    uuid: string
}

export interface IDwGeoFilter extends IDwFilter {
    feature:string;
    widgetInstanceId: string,
    widgetInstanceTitle: string,
}

export class DwQuery {
    definitionId: number;
    entity: string;
    feature?: string;
    timeSeries?: boolean;
    dimensions:IDwDimension[];
    measures:IDwMeasure[];
    filters:IDwFilter[];
    timeSeriesFunction?: string;

    constructor(definitionId: number, entityName: string, featureType?: string, timeSeries?: boolean) {
        this.definitionId = definitionId;
        this.entity = entityName;
        this.feature = featureType;
        this.timeSeries = timeSeries;
        this.dimensions = [];
        this.measures = [];
        this.filters = [];
    }

    addDimension(dimension:IDwDimension) {
        this.dimensions.push(dimension);
    }

    addMeasure(measure:IDwMeasure) {
        this.measures.push(measure);
    }

    addFilter(filter:IDwFilter) {
        this.filters.push(filter);
    }
}

export class InviteUser {
    email: string;
    orgId: string;
    constructor( email: string, orgId: string) {
        this.orgId = orgId;
        this.email = email;
    }
}